const isPortalHost = hostname => {
  return /^www\.([^.]+)\.svenskaspelportal\.se$/.test(hostname) || hostname === 'www.svenskaspelportal.se';
};
const getIamLoginBaseUrl = () => {
  return '';
};
const isLocalHost = hostname => {
  return hostname === 'localhost' || hostname === '127.0.0.1' || hostname.startsWith('local.') || hostname.includes('.local.');
};
export const shouldUseIamFlowForCurrentHost = (isIamFeatureEnabled = false) => {
  if (typeof window === 'undefined') {
    return false;
  }
  if (!isIamFeatureEnabled) {
    return false;
  }
  const {
    hostname
  } = window.location;
  if (isLocalHost(hostname)) {
    return true;
  }
  if (hostname.includes('ombudslogin.')) {
    return true;
  }
  return isPortalHost(hostname);
};
export const getIamLoginUrl = path => `${getIamLoginBaseUrl()}${path}`;